const imgAttributeMapping = {
    width: 'w',
    height: 'h',
    webp: 'rw',
    png: 'rp',
    jpg: 'rj',
    stretch: 's',
    crop: 'c',
};
const constructGoogleImageParams = (url, config) => {
    const baseUrl = url.indexOf('=') >= 0 ? url.substring(0, url.indexOf('=')) : url;
    const params = [];
    Object.entries(config).forEach(([key, value]) => {
        if (!value)
            return;
        if (key === 'format') {
            params.push(imgAttributeMapping[value]);
            return;
        }
        if (key === 'size' && value) {
            params.push(`${imgAttributeMapping[key]}0`);
            return;
        }
        if (imgAttributeMapping[key]) {
            if (typeof value === 'boolean') {
                if (value) {
                    params.push(`${imgAttributeMapping[key]}`);
                    return;
                }
                return;
            }
            params.push(`${imgAttributeMapping[key]}${value}`);
        }
    });
    return params.length > 0 ? `${baseUrl}=${params.join('-')}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
    if (imageUrl && imageUrl.includes('googleusercontent.com'))
        return constructGoogleImageParams(imageUrl, config);
    return imageUrl;
};

export { constructGoogleImageParams, getImageUrlFromGoogleUserContent };
